import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <main className="not-found-page">
      <span className="not-found-code">404</span>
      <h1>页面走丢了</h1>
      <p>这里没有可以处理的文档，回到转换页重新开始吧。</p>
      <Link className="primary-action" to="/pdf-to-word">
        <ArrowLeft size={18} />
        返回 PDF 转 Word
      </Link>
    </main>
  );
}
